export default __webpack_public_path__ + "static/media/inspiration.8ef3e203.svg";